export default __webpack_public_path__ + "static/media/linkedin.c9b39367.svg";